import store from "../../store/store"
import { DialogsHub } from "../hubs/dialogs"

export const dialogsHub = new DialogsHub(store)
